module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9e1sPg/tc-custom/9781466822047.jpg?1737774788143",
      "alt": "This image is the cover for the book Voidfarer, The Moonworlds Saga"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Voidfarer, The Moonworlds Saga\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v(" At first Wayfarer Inspector Danolarian thought the huge oval thing that had fallen from the sky was a dragon's egg. When it opened, however, he knew that it was much, much worse. His world was being invaded by pitiless sorcerers from Lupan, who could sweep whole armies aside, and even defeat the invulnerable glass dragons. Surrender or flight were the only options ... but not for Inspector Danolarian, his Wayfarer Constables, and his sweetheart, the sorceress Lavenci."), _c('br'), _c('br'), _vm._v(" Although Danolarian is no sorcerer, he's no ordinary Wayfarer either. Faced with civilization crumbling around him, and organized resistance shattered by the invincible magic of the Lupanians, he chances upon an unlikely ally and begins to fight back. It won't be easy, for he has to rally the demoralized sorcerers of Alberin, organize its terrified citizens, stay one step ahead of his own past, and, most importantly, survive a dinner party with Lavenci's mother. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sean McMullen\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0